// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hr5jM","left":"styles_left__1iGKQ","desktopActions":"styles_desktopActions__3lHqA","title":"styles_title__3v1Al"};